import nls from '../es/CardSuccess.js';
export default {
  ...nls,
  'Proof of contracting the': 'Comprobante de operación de tu contratación de la',
};
